import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";

const getWindowSize = () => {
	return {
		width: window.innerWidth,
		height: window.innerHeight,
	};
};

/**
 * A React component that puts a windowshade over the site. We usually use this
 * for modals or other UI elements that need to be at the top of the visual
 * hierarchy of the site.
 * @param {Array} [props.children] An array of React components that will be
 *                                 children of the FullscreenOverlay.
 */
class FullscreenOverlay extends React.Component {
	static propTypes = {
		children: PropTypes.node,
		siblings: PropTypes.node,
		onClick: PropTypes.func,
		scrollRef: PropTypes.object,
		className: PropTypes.string,
	};

	static defaultProps = {
		children: null,
		siblings: null,
		onClick: noop,
		scrollRef: null,
		className: "",
	};

	constructor(props) {
		super(props);

		if (props.scrollRef) {
			this._overlay = props.scrollRef;
		} else {
			this._overlay = React.createRef();
		}
	}

	state = getWindowSize();

	componentDidMount() {
		window.addEventListener("resize", this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	handleResize = () => {
		this.setState(getWindowSize());
	};

	render() {
		const onClick = this.props.onClick || noop;

		return (
			<React.Fragment>
				<div
					style={this.state}
					className={`FullscreenOverlay ${this.props.className}`}
					onClick={onClick}
					role="presentation"
				>
					<div className="FullscreenOverlay-inner" ref={this._overlay}>
						{this.props.children}
					</div>
				</div>
				<div className="FullscreenOverlay-content">
					{this.props.siblings}
				</div>
			</React.Fragment>
		);
	}
}

FullscreenOverlay.defaultProps = {
	className: "",
};

export default FullscreenOverlay;



// WEBPACK FOOTER //
// ./src/shared/components/FullscreenOverlay.jsx